<template>
  <v-simple-table
    class="rounded-card pb-3 overflow-hidden"
    fixed-header
  >
    <template v-slot:default>
      <thead>
      <tr>
        <th>Código interno</th>
        <th style="min-width: 300px">Produto</th>
        <th>Quantidade</th>
        <th>Centro de custo</th>
        <th class="text-center" style="min-width: 100px"></th>
      </tr>
      </thead>
      <tbody>
        <template v-for="(produto) in aprovacao.produtos">
          <tr style="height: 55px" :key="produto.id">
            <td>
              <px-situacao-user-aprovacao show-as-icon class="mr-3" :item-aprovacao="produto"/>
              {{ codigoProduto(produto) }}
            </td>
            <td>
              <px-produto-descricao v-if="produto.produto"
                                    :show-codigo="false"
                                    :especificacao="produto.especificacaoProduto"
                                    :produto="produto.produto"/>
              <span v-if="!produto.produto">
                {{ produto.especificacaoProduto }}
              </span>
            </td>
            <td>
              {{
                produto.quantidade
                  | number(getCurrencyFormat(casasDecimaisItem(produto)))
              }}
              {{ produto.unidadeMedida.descricao }}
            </td>
            <td>
              {{ centroCusto(produto) }}
            </td>
            <td class="text-right">
              <px-anexo read-only
                        v-model="produto.arquivos"
                        download-base-path="files/download-comprador"/>
              <px-detalhes-produto
                :produto="produto"
                show-projeto
                show-obs-externa
                show-obs-interna
                show-finalidade-compra
                show-data-previsao-entrega
                :show-motivo-recusa="isItemCancelado(produto)">
                <template v-slot:bottom>
                  <px-campos-integracao
                    v-if="cadastrosAdicionaisItem(produto)
                    && erpCamposIntegracao
                    && !isCasaShopping"
                    type="requisicao-produtos-view"
                    :form-data="cadastrosAdicionaisItem(produto)"
                    text-class="small-text"/>
                </template>
              </px-detalhes-produto>
              <px-aprovacao-solicitacao-detalhes-produto-modal-view :item-id="produto.id"
                                                                    :aprovacao-id="aprovacao.id"
                                                                    @update="onUpdate"/>
              <px-aprovacao-solicitacao-produto-controls :aprovacao-id="aprovacao.id"
                                                         :item-aprovacao="produto"
                                                         @update="onUpdate"/>
              <v-tooltip top v-if="exibirEstoque">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="toggleExpand(produto)">
                    <v-icon>
                      {{ expandedRow === produto.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Visualizar estoque</span>
              </v-tooltip>
            </td>
          </tr>
          <tr :key="`${produto.id}-expanded`" v-if="expandedRow === produto.id">
            <td colspan="5" class="text-start">
              <px-listagem-estoque :produto-id="produto.produto.id"/>
            </td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import { ErpCamposIntegracao, SituacaoAprovacao } from 'px-business-components';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import AprovacaoSolicitacaoDetalhesProdutoModalView
  from '@/modules/aprovacao-solicitacao/detalhes-produtos/AprovacaoSolicitacaoDetalhesProdutoModalView.vue';
import AprovacaoSolicitacaoProdutoControls
  from '@/modules/aprovacao-solicitacao/components/AprovacaoSolicitacaoProdutoControls.vue';
import ListagemEstoque
  from '@/modules/estoque/ListagemEstoque.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
    showEstoque: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedRow: null,
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['erpCamposIntegracao', 'hasEstoque']),
    codigoProduto() {
      return item => (item.produto ? item.produto.codigo : '-');
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casasDecimaisItem() {
      return item => (item.produto ? item.produto.casasDecimais : null);
    },
    cadastrosAdicionaisItem() {
      return (item) => {
        if (!item.cadastrosAdicionais || !item.cadastrosAdicionais.length) {
          return null;
        }
        return cadastrosAdicionaisToMap(item.cadastrosAdicionais);
      };
    },
    exibirEstoque() {
      return this.hasEstoque && this.showEstoque;
    },
    centroCusto() {
      return (produto) => {
        if (!this.isCasaShopping) {
          return produto.centroCusto ? produto.centroCusto.descricao : '-';
        }
        return this.cadastrosAdicionaisItem(produto)?.CONTA_DESPESA || '-';
      };
    },
    isCasaShopping() {
      return this.erpCamposIntegracao === ErpCamposIntegracao.keys.CASA_SHOPPING.key;
    },
    isItemCancelado() {
      return item => SituacaoAprovacao.keys.RECUSADO.key === item.situacao;
    },
  },
  methods: {
    toggleExpand(produto) {
      if (this.expandedRow === produto.id) {
        this.expandedRow = null;
      } else {
        this.expandedRow = produto.id;
      }
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesProdutoModalView: AprovacaoSolicitacaoDetalhesProdutoModalView,
    pxAprovacaoSolicitacaoProdutoControls: AprovacaoSolicitacaoProdutoControls,
    pxListagemEstoque: ListagemEstoque,
  },
};
</script>
